import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { SnackbarProvider } from 'notistack';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import client from '../lib/apolloClient';
import themes from '../lib/themes';
import QuickNotesForm from '../components/Dashboard/QuickNotesForm';

const QuickNotesFormContainer = (props, railsContext) => {
  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbQuickNotes',
  });
  
  const jss = create({
    ...jssPreset(),
  });
  
  const theme = themes[railsContext?.theme_name] || themes.findBobTheme;
  window.locale = railsContext?.i18nLocale || 'en';

  return (
    <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbQuickNotes-">
      <MuiThemeProvider theme={createMuiTheme(theme)}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3}>
          <ApolloProvider client={client}>
            <QuickNotesForm {...props} />
          </ApolloProvider>
        </SnackbarProvider>
      </MuiThemeProvider>
    </JssProvider>
  );
};

export default QuickNotesFormContainer; 